export default __webpack_public_path__ + "static/media/Android.e5e5ed7e.svg";